import React, { Component } from 'react'
import { connect } from 'react-redux'

import { closeOverlay, isOverlayOpen } from '../../../actions/common'

import './overlay.scss'

class Overlay extends Component {

  constructor (props) {
    super(props)
    this.isShowing = false
  }

  componentWillUnmount () {
    // Force remove overlayId from stack when unmounting
    this.props.closeOverlay(this.props.overlayId, true)
  }

  componentDidUpdate () {
    // Trigger callbacks when overlay changes between shown/hidden
    let isOpen = this.props.isOverlayOpen(this.props.overlayId)
    if (isOpen !== this.isShowing) {
      if (isOpen) {
        this.props.onShow()
      } else {
        this.props.onHide()
      }
      this.isShowing = isOpen
    }
  }

  render () {
    let isOpen = this.props.isOverlayOpen(this.props.overlayId)

    if (!isOpen) return null
    let overlayClass = 'element-overlay'
    if (this.props.noContentScroll) overlayClass += ` no-content-scroll`
    if (this.props.extraClassName) overlayClass += ` ${this.props.extraClassName}`

    return (
      <div className={overlayClass}>
        {this.props.children}
      </div>
    )
  }
}

Overlay.contextTypes = {
  router: React.PropTypes.object.isRequired
}

Overlay.propTypes = {
  overlayId: React.PropTypes.string.isRequired
}

Overlay.defaultProps = {
  onShow: () => { },
  onHide: () => { }
}

function mapStateToProps (state) {
  return {
    auth: state.auth,
    overlaysLength: state.common.overlays.length  // (makes react detect the change, not sure why it doesn't detect this through the array)
  }
}

export default connect(mapStateToProps, {
  closeOverlay,
  isOverlayOpen
})(Overlay)



// WEBPACK FOOTER //
// ./src/app/shared/elements/overlay/index.js